export const GET_BOOKING_DOCUMENTS_UI = 'GET_BOOKING_DOCUMENTS_UI';
export const ADD_BOOKING_DOCUMENTS_UI = 'ADD_BOOKING_DOCUMENTS_UI';
export const UPDATE_BOOKING_DOCUMENT_UI = 'UPDATE_BOOKING_DOCUMENT_UI';
export const DELETE_BOOKING_DOCUMENT_UI = 'DELETE_BOOKING_DOCUMENT_UI';
